import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// ОБЕРТКА С ЧЕРНЫМ ФОНОМ
const Section = styled.section`
  width: 100%;
  padding: 120px 20px;
  background: #000;
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;

// Работает только на десктопе
const DesktopContainer = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
`;

const GridContainer = styled.div`
  display: grid;
  gap: 4rem;
  grid-template-columns: 1fr;

  @media (min-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
`;

// ТЕКСТОВАЯ ЧАСТЬ
const TextBlock = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Title = styled.h2`
  font-size: clamp(2.5rem, 5vw, 4rem);
  margin: 0;
  letter-spacing: -0.03em;
  background: linear-gradient(120deg, #fff, #9ca3af, #ffffff, #6b7280);
  background-size: 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 10s infinite alternate;

  @keyframes gradientMove {
    0% { background-position: 0%; }
    100% { background-position: 100%; }
  }
`;

const Subtitle = styled.h3`
  font-size: 1.2rem;
  opacity: 0.7;
  font-weight: 400;
  margin: 0;
`;

const Description = styled.p`
  font-size: 1.1rem;
  opacity: 0.8;
  line-height: 1.6;
  max-width: 500px;
`;

// ФОРМА
const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background: rgba(255, 255, 255, 0.06);
  padding: 2rem;
  border-radius: 20px;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255,255,255,0.1);
`;

const Input = styled.input`
  padding: 1rem 1.2rem;
  font-size: 1rem;
  border-radius: 12px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.15);
  color: white;
  outline: none;

  &:focus {
    border-color: white;
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
`;

const TextArea = styled.textarea`
  padding: 1rem 1.2rem;
  font-size: 1rem  ;
  min-height: 130px;
  border-radius: 12px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.15);
  color: white;
  outline: none;
  resize: none;

  &:focus {
    border-color: white;
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
`;

const Button = styled.button`
  padding: 1rem 1.5rem;
  background: white;
  color: black;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

// КОМПОНЕНТ — ПЕРЕВЕДЁННЫЙ
const ContactUs = () => {
  const { t } = useTranslation();

  return (
    <Section>
      <DesktopContainer>
        <GridContainer>

          {/* TEXT SIDE */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            style={{ width: '100%' }}
          >
            <TextBlock>
              <Subtitle>{t('contact_subtitle')}</Subtitle>
              <Title>{t('contact_title')}</Title>
              <Description>{t('contact_desc')}</Description>
            </TextBlock>
          </motion.div>    

          {/* FORM SIDE */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            style={{ width: '100%' }}
          >
            <Form onSubmit={(e) => e.preventDefault()}>
              <Input placeholder={t('contact_name')} required />
              <Input placeholder={t('contact_email')} type="email" required />
              <TextArea placeholder={t('contact_message')} />
              <Button type="submit">{t('contact_button')}</Button>
            </Form>
          </motion.div>        

        </GridContainer>
      </DesktopContainer>
    </Section>
  );
};

export default ContactUs;